import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import { BootstrapVue } from 'bootstrap-vue'
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

const VUE_APP_SENTRY_DSN = process.env.VUE_APP_SENTRY_DSN || 'https://525edbe1b47d382d4a3952a497c6e8ae@sentry.torbeev.info/1';
const NODE_ENV = process.env.NODE_ENV || 'production';

Vue.config.productionTip = false

Vue.use(BootstrapVue);

Sentry.init({
  Vue,
  dsn: VUE_APP_SENTRY_DSN,
  environment: NODE_ENV,

  integrations: [
    new BrowserTracing({
      routingInstrumentation:
        Sentry.vueRouterInstrumentation(router),
    }),
  ],

  tracesSampleRate: 0.1,
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
